import React from 'react';

export const recentList = [
    {
        image: 'apple',
        title: "iOS app launched",
        description: "Fgram project’s new iOS app is launched today",
        date: "20 March, 2017",
        color: "bg-primary"
    },
    {
        image: 'android',
        title: "Android app launched",
        description: "It is a long established fact that a reader will be distracted by the",
        date: "27 Feb, 2017",
        color: "bg-danger"
    },
    {
        image: 'dropbox',
        title: "PSD file added to dropbox",
        description: "There are many variations of passages of Lorem Ipsum available",
        date: "24 Feb, 2017",
        color: "bg-info"
    },

];

export const projects = [
    {
        id: 1,
        name: "Jambo Admin",
        date: "Oct 21",
        status: "Completed",
        color: "primary"

    },
    {
        id: 2,
        name: 'Chatbull',
        date: "Oct 22",
        status: "On Hold",
        color: "info"
    },
    {
        id: 3,
        name: 'Mouldifi',
        date: "Nov 12",
        status: "Delayed",
        color: "warning"
    },
    {
        id: 4,
        name: 'Simplify Timer',
        date: "Nov 21",
        status: "Cancelled",
        color: "danger"
    },
    {
        id: 5,
        name: 'Clevex',
        date: "jan 21",
        status: "Completed",
        color: "primary"
    },

];

export const dailyFeedData = [

    {
        id: 1,
        desc: [<a href="javascript:void(0)">Guptil</a>, " has sent you an invitation to join project ",
            <a href="javascript:void(0)">Mouldifi</a>],
        image: 'http://via.placeholder.com/256x256',
        time: "Today 06:30 pm - 12.10.17",
        updateTime: "5m ago"
    },
    {
        id: 2,
        desc: [<a href="javascript:void(0)">Mich</a>, " uploaded 6 new photos in ",
            <a href="javascript:void(0)">Art Lovers</a>, " group"],
        image: 'http://via.placeholder.com/256x256',
        time: "Today 06:30 pm - 12.10.17",
        updateTime: "3m ago"
    },

    {
        id: 3,
        desc: [<a href="javascript:void(0)">Joshua</a>, " has shared a post asaying this is bigening."],
        image: 'http://via.placeholder.com/256x256',
        time: "Today 06:30 pm - 12.10.17",
        updateTime: "1 day ago",
        isSocial: "true"
    },

    {
        id: 4,
        desc: [<a href="javascript:void(0)">Stella</a>, " has sent you an invitation"],
        image: 'http://via.placeholder.com/256x256',
        time: "Today 06:30 pm - 12.10.17",
        updateTime: "2 day ago",
    },
    {
        id: 5,
        desc: [<a href="javascript:void(0)">Kadir</a>, " uploaded 1 new photos in"],
        image: 'http://via.placeholder.com/256x256',
        time: "Yesterday 01:30 pm - 11.10.17",
        updateTime: "3 day ago",
    },

];

export const products = [
    {
        image: 'http://via.placeholder.com/500x330',
        title: "Up unpacked friendly",
        description: "Contrary to popular belief, Lorem Ipsum is not simply random text.",
        mrp: 250,
        offerPrice: 200
    },
    {
        image: 'http://via.placeholder.com/500x330',
        title: "It allowance prevailed",
        description: "It is a long established fact that a reader will be distracted",
        mrp: 250,
        offerPrice: 200
    },
    {
        image: 'http://via.placeholder.com/500x330',
        title: "Case read they must",
        description: "There are many variations of passages of Lorem Ipsum available",
        mrp: 250,
        offerPrice: 200
    },
    {
        image: 'http://via.placeholder.com/500x330',
        title: "Too carriage attended",
        description: "The standard chunk of Lorem Ipsum used since the 1500s",
        mrp: 250,
        offerPrice: 200
    },
    {
        image: 'http://via.placeholder.com/500x330',
        title: "Case read they must",
        description: "There are many variations of passages of Lorem Ipsum available",
        mrp: 400,
        offerPrice: 370
    },
    {
        image: 'http://via.placeholder.com/500x330',
        title: "Too carriage attended",
        description: "The standard chunk of Lorem Ipsum used since the 1500s",
        mrp: 250,
        offerPrice: 200
    },
];

export const appNotification = [

    {
        id: 1,
        title: "Invitation",
        desc: [<a href="javascript:void(0)">Stella</a>, " has sent you an invitation to join project ",
            <a href="javascript:void(0)">Mouldifi</a>],
        image: 'http://via.placeholder.com/256x256'
    },
    {
        id: 2,
        title: "Message",
        desc: [<a href="javascript:void(0)">Jeson Born</a>, " Need your help on ",
            <a href="javascript:void(0)">Jambo</a>],
        image: 'http://via.placeholder.com/256x256'
    },
    {
        id: 3,
        title: "Invitation",
        desc: [<a href="javascript:void(0)">Guptil</a>, " has sent you an invitation to join project ",
            <a href="javascript:void(0)">Mouldifi</a>],
        image: 'http://via.placeholder.com/256x256'
    },
    {
        id: 4,
        title: "Invitation",
        desc: [<a href="javascript:void(0)">Alex Dolgove</a>, " has sent you an invitation to join project ",
            <a href="javascript:void(0)">Mouldifi</a>],
        image: 'http://via.placeholder.com/256x256'
    },
];

export const announcementsNotification = [
    {
        id: 5,
        title: "Invitation",
        desc: [<a href="javascript:void(0)">Alex Dolgove</a>, " has sent you an invitation to join project ",
            <a href="javascript:void(0)">Mouldifi</a>],
        image: 'http://via.placeholder.com/256x256'
    },
    {
        id: 6,
        title: "Message",
        desc: [<a href="javascript:void(0)">Jeson Born</a>, " Need your help on ",
            <a href="javascript:void(0)">Jambo</a>],
        image: 'http://via.placeholder.com/256x256'
    }, {
        id: 7,
        title: "Invitation",
        desc: [<a href="javascript:void(0)">Stella</a>, " has sent you an invitation to join project ",
            <a href="javascript:void(0)">Mouldifi</a>],
        image: 'http://via.placeholder.com/256x256'
    },
    {
        id: 8,
        title: "Invitation",
        desc: [<a href="javascript:void(0)">Guptil</a>, " has sent you an invitation to join project ",
            <a href="javascript:void(0)">Mouldifi</a>],
        image: 'http://via.placeholder.com/256x256'
    },
];

export const marketingData = [
    {
        id: 1,
        name: 'Facebook Ads',
        desc: '63 Likes, 387 Shares',
        icon: 'facebook',
        color: 'bg-indigo lighten-1',
        budget: 570,
        growth: 20
    },

    {
        id: 2,
        name: 'Twitter Ads',
        desc: '43 Likes, 545 Shares',
        icon: 'twitter',
        color: 'bg-light-blue accent-2',
        budget: 811,
        growth: -5
    },

    {
        id: 3,
        name: 'Instagram',
        desc: '83 Follows, 210 Likes',
        icon: 'instagram',
        color: 'bg-brown lighten-1',
        budget: 685,
        growth: 20
    },

    {
        id: 4,
        name: 'LinkedIn',
        desc: '23 Shares, 764 Likes',
        icon: 'linkedin',
        color: 'bg-light-blue darken-3',
        budget: 868,
        growth: 25
    },

];


// WEBPACK FOOTER //
// ./app/routes/dashboard/routes/Intranet/data.js